import { createAction, props } from '@ngrx/store';

export const CARRIER_NETWORK = {
	ACCOUNTS_LIST: {
		GET: createAction('[CARRIER_NETWORK] Get accounts list', props<any>()),
		SUCCESS: createAction('[CARRIER_NETWORK] Get accounts list success', props<any>()),
		FAILURE: createAction(
			'[CARRIER_NETWORK] Get accounts list failed',
			props<{ payload: { message: string } }>()
		),
	},

	SET: {
		PAGE: createAction('[CARRIER_NETWORK] Set carrier network page', props<any>()),
		PAGE_SIZE: createAction('[CARRIER_NETWORK] Set carrier network page size', props<any>()),
		FILTER_LIST: createAction(
			'[CARRIER_NETWORK] set carrier network filters list',
			props<{ filtersList: any[] }>()
		),
		SORT_LIST: createAction(
			'[CARRIER_NETWORK] set carrier network sorts list',
			props<{ sortList: any[] }>()
		),
	},

	RESET_STATE: createAction('[CARRIER_NETWORK] Reset page state', props<any>()),
};
